import { chunk } from 'lodash';
export const prepareIdsForChunking = (ids, chunkSize) => {
  const uniqueIds = ids ? Array.from(new Set(ids)) : [];
  return chunk(uniqueIds, chunkSize);
};
export const COMMON_PAGE_LIMIT = 100;
//# sourceMappingURL=prepare-ids-for-chunking.js.map